import {
  SET_INSTITUTE_DATA,
  SET_UNIVERSITY_LIST,
} from 'modules/Settings/actions'

const initialState = {
  instituteData: {},
  universityList: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_INSTITUTE_DATA:
      return {
        ...state,
        instituteData: action.list,
      }
    case SET_UNIVERSITY_LIST:
      return {
        ...state,
        universityList: action.list,
      }
    default:
      return state
  }
}
